// PURE DATA + loader arrows. Admin-only module: no public routes or menu items.
import type { ModuleManifest } from '../types';

export const emailModule: ModuleManifest = {
  id: 'email',
  routes: [],
  adminPanel: __MODULE_ADMIN__
    ? { title: 'Email Center', icon: 'email', path: 'emails', load: () => import('./admin/EmailCenterPanel') }
    : undefined,
};
